<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows.length || tableSelectedRows.length !== 1">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiColumnList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="文章查询">
				<div style="display: flex;justify-content: space-between;align-items: center;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 100px;">所属栏目：</div>
						<!-- <a-select v-model="query.columnId" style="width: 100%;" placeholder="请选择所属栏目" allowClear>
							<a-select-option v-for="item in columnList" :key="item.columnId" :value="item.columnId">{{item.columnName}}</a-select-option>
						</a-select> -->
						<a-cascader
							style="width: 100%;"
							:options="columnList"
							:display-render="displayRender"
							expand-trigger="hover"
							placeholder="请选择所属栏目"
							@change="onChange"
						/>
					</div>
					<div style="display: flex; justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiArticleQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						产品分类列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="articleId" :loading="tableLoading" :pagination="false">

				<span slot="articleTitle" slot-scope="articleTitle">
					<a-button type="link" @click="edit(articleTitle)" style="padding: 0 4px;">{{articleTitle.articleTitle}}</a-button>
				</span>
				<span slot="columnId" slot-scope="columnId">
					{{columnNameList.find(item => item.columnId == columnId.columnId)?.columnName || '-'}}
				</span>
				<span slot="isTop" slot-scope="isTop">
					{{isTop.isTop==3?"是":"否"}}
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>


		<!-- 添加弹窗 -->
		<a-modal class="qa-modal" title="添加" width="100%" :visible="addVisible" :confirm-loading="addConfirmLoading" @cancel="handleCancel" :footer="null" :maskClosable="false" :keyboard="false" >
            <div style="width: 80%;background-color: #fff;">
				<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
						<div class="qa-table-item-3">
							<a-form-model-item label="栏目名称" >
								<a-cascader
									style="width: 100%;"
									:options="columnList"
									:display-render="displayRender"
									expand-trigger="hover"
									placeholder="请选择所属栏目"
									@change="onChangeAdd"
								/>
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="文章标题" has-feedback prop="priceCode">
								<a-input v-model="addForm.articleTitle" placeholder="请输入文章标题" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="副标题" has-feedback prop="priceCode">
								<a-input v-model="addForm.subTitle" placeholder="请输入副标题" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-3">
							<a-form-model-item label="作者" has-feedback prop="priceCode">
								<a-input v-model="addForm.author" placeholder="请输入作者" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="简述" has-feedback prop="priceCode">
								<a-input v-model="addForm.articleResume" placeholder="请输入简述" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="封面图" has-feedback prop="coverImage">
								<ImageUpload 
									v-model="addForm.coverImage" 	
									:limit="1" 
									:fileSize="1" 
									:fileType="['png', 'jpg', 'jpeg']" 
									:isShowTip="true"
									@input="uploadPicUrlAdd"
								/>
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1-remarks">
							<a-form-model-item label="图集" has-feedback prop="atlas">
								<ImageUpload 
									v-model="addForm.atlas" 	
									:limit="5" 
									:fileSize="1" 
									:fileType="['png', 'jpg', 'jpeg']" 
									:isShowTip="true"
									@input="uploadAtlasAdd"
								/>
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="正文" has-feedback prop="articleInfo" style="width: 505px;">
								<div style="border: 1px solid #ccc;">
									<Toolbar style="border-bottom: 1px solid #ccc"  :editor="wangEditor.editor"  :defaultConfig="wangEditor.toolbarConfig" :mode="wangEditor.mode"/>
									<Editor style="height: 500px; overflow-y: hidden;" v-model="addForm.articleInfo" :defaultConfig="wangEditor.editorConfig" :mode="wangEditor.mode" @onCreated="wangEditorFinish"/>
								</div>
								
							</a-form-model-item>
						</div>
						<div class="qa-table-item-3">
							<a-form-model-item label="排序" has-feedback prop="articleSort">
								<a-input v-model="addForm.articleSort" placeholder="请输入排序" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1-remarks">
							<a-form-model-item label="是否置顶" has-feedback prop="isTop">
								<a-radio-group name="isTop" v-model="addForm.isTop">
									<a-radio :value="2">否</a-radio>
									<a-radio :value="3">是</a-radio>
								</a-radio-group>
							</a-form-model-item>
						</div>
							<div class="qa-table-item-1">
							<a-form-model-item label="显示日期" has-feedback prop="articleDate">
								<a-input v-model="addForm.articleDate" placeholder="请输入显示日期" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="显示时间" has-feedback prop="articleTime">
								<a-input v-model="addForm.articleTime" placeholder="请输入显示时间" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="显示地址" has-feedback prop="articleAddress">
								<a-input v-model="addForm.articleAddress" placeholder="请输入显示地址" />
							</a-form-model-item>
						</div>
					
						<div class="qa-table-item-1">
							<a-form-model-item label="样式代码" has-feedback prop="styleConfig">
								<a-input v-model="addForm.styleConfig" placeholder="请输入样式代码" />
							</a-form-model-item>
						</div>
						<div style="text-align: center;">
							<a-button style="margin-right: 20px;" @click="handleCancel">返回</a-button>
							<a-button type="primary" @click="addHandleOk">保存</a-button>
						</div>
					</a-form-model>
				</div>
		</a-modal>

		<!-- 修改弹窗 -->
		<a-modal class="qa-modal" title="修改" width="100%" :visible="editVisible" :confirm-loading="editConfirmLoading" @cancel="handleCancel" :footer="null" :maskClosable="false" :keyboard="false" >
			 <div style="width: 80%;background-color: #fff;">
				<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
						<div class="qa-table-item-3">
							<a-form-model-item label="栏目名称" >
								<a-cascader
									style="width: 100%;"
									v-model="editForm.columnIdPath"
									:options="columnList"
									:display-render="displayRender"
									expand-trigger="hover"
									placeholder="请选择所属栏目"
									@change="onChangeEdit"
								/>
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="文章标题" has-feedback prop="priceCode">
								<a-input v-model="editForm.articleTitle" placeholder="请输入文章标题" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="副标题" has-feedback prop="priceCode">
								<a-input v-model="editForm.subTitle" placeholder="请输入副标题" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-3">
							<a-form-model-item label="作者" has-feedback prop="priceCode">
								<a-input v-model="editForm.author" placeholder="请输入作者" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="简述" has-feedback prop="priceCode">
								<a-input v-model="editForm.articleResume" placeholder="请输入简述" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="封面图" has-feedback prop="coverImage">
								<ImageUpload 
									v-model="editForm.coverImage" 	
									:limit="1" 
									:fileSize="1" 
									:fileType="['png', 'jpg', 'jpeg']" 
									:isShowTip="true"
									@input="uploadPicUrlAdd"
								/>
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="图集" has-feedback prop="atlas">
								<ImageUpload 
									v-model="editForm.atlas" 	
									:limit="5" 
									:fileSize="1" 
									:fileType="['png', 'jpg', 'jpeg']" 
									:isShowTip="true"
									@input="uploadAtlasEdit"
								/>
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="正文" has-feedback prop="articleInfo" style="width: 505px;">
								<!-- <a-textarea placeholder="在这里输入内容" :rows="4" v-model="addForm.articleInfo" /> -->
								<div style="border: 1px solid #ccc;">
									<Toolbar style="border-bottom: 1px solid #ccc"  :editor="wangEditor.editor"  :defaultConfig="wangEditor.toolbarConfig" :mode="wangEditor.mode"/>
									<Editor style="height: 500px; overflow-y: hidden;" v-model="editForm.articleInfo" :defaultConfig="wangEditor.editorConfig" :mode="wangEditor.mode" @onCreated="wangEditorFinish"/>
								</div>
								
							</a-form-model-item>
						</div>
						<div class="qa-table-item-3">
							<a-form-model-item label="排序" has-feedback prop="articleSort">
								<a-input v-model="editForm.articleSort" placeholder="请输入排序" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1-remarks">
							<a-form-model-item label="是否置顶" has-feedback prop="isTop">
								<a-radio-group name="isTop" v-model="editForm.isTop">
									<a-radio :value="2">否</a-radio>
									<a-radio :value="3">是</a-radio>
								</a-radio-group>
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="显示日期" has-feedback prop="articleDate">
								<a-input v-model="editForm.articleDate" placeholder="请输入显示日期" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="显示时间" has-feedback prop="articleTime">
								<a-input v-model="editForm.articleTime" placeholder="请输入显示时间" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="显示地址" has-feedback prop="articleAddress">
								<a-input v-model="editForm.articleAddress" placeholder="请输入显示地址" />
							</a-form-model-item>
						</div>
						<div class="qa-table-item-1">
							<a-form-model-item label="样式代码" has-feedback prop="styleConfig">
								<a-input v-model="editForm.styleConfig" placeholder="请输入样式代码" />
							</a-form-model-item>
						</div>
						<div style="text-align: center;">
							<a-button style="margin-right: 20px;" @click="handleCancel">返回</a-button>
							<a-button type="primary" @click="editHandleOk">保存</a-button>
						</div>
					</a-form-model>
				</div>
		</a-modal>
		
		
	</div>
</template>

<script>
	import moment from 'moment'
	import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
    import ImageUpload from '@/components/ImageUpload'
	export default {
		components: { ImageUpload,Editor, Toolbar },
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				//类型列表
				typeList: [
                     {
                        label:'导航',
                        value:1
                    },
                    {
                        label:'其他',
                        value:2
                    },
                ],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					columnId: undefined,
				},
				mainNavigation:{},
				tableData: [],
				columnList: [],
				columnNameList: [],
				tableColumns: [
                    { title: '文章标题', align: 'center',  scopedSlots: { customRender: 'articleTitle' } },
					{ title: '栏目', align: 'center',  scopedSlots: { customRender: 'columnId' } },
					{ title: '作者', dataIndex: 'author', align: 'center' },
					{ title: '排序', dataIndex: 'articleSort', align: 'center' },
					{ title: '置顶状态', align: 'center',  scopedSlots: { customRender: 'isTop' } },

					// { title: '操作', align: 'center', scopedSlots: { customRender: 'tableAction' } },
					
				],
				tableLoading: false,
				tableSelectedRows: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorId: undefined,
					columnName: '',
					columnImg: '',
					columnSort: 0,
					columnState:3,
					showPosition: 1,
					jumpUrl: '',
					columnId: undefined,
				},
				addRules: {
					columnSort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
					columnName: [{ required: true, message: '栏目名称不能为空', trigger: 'blur' }],
					// priceId: [{ required: true, message: '请选择产品', trigger: 'change' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					facilitatorId: undefined,
					columnName: '',
					columnImg: '',
					columnSort: 0,
					columnState:3,
					showPosition: 1,
					jumpUrl: '',
					columnId: undefined,
					columnIdPath: [],
				},
				// 修改弹窗-end
				wangEditor: {
					editor: null,
					toolbarConfig: { excludeKeys: ['group-video', 'fullScreen'] },
					editorConfig: {
						placeholder: '请输入内容...', 
						MENU_CONF:{
							uploadImage:{
								server: this.navigation.apiUploadFiles,
								fieldName: 'fileName',
								headers: {
									userToken: window.sessionStorage.getItem('token')
								},
								customInsert:(res, insertFn)=>{
									console.log(res.data);
									insertFn(this.navigation.url + res.data, "", "")
								}
							},
						},
					},
					mode: 'default', // 'default' or 'simple'
				}
			};
		},
		methods: {
            //获取服务商列表
			async apiColumnList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiColumnList, {"staffId":window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.columnNameList = res.data
					this.columnList = this.buildCascadeOptions(res.data)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			// 递归构造级联所需数据结构
			buildCascadeOptions(list) {
				// 将 list 按 parentId 分组
				const groupMap = {};
				list.forEach(item => {
					const key = item.parentId || 0;
					if (!groupMap[key]) groupMap[key] = [];
					groupMap[key].push(item);
				});
				// 递归构造 children
				const build = (parentId = 0) => {
					const nodes = groupMap[parentId] || [];
					return nodes.map(item => ({
						label: item.columnName,
						value: item.columnId,
						children: build(item.columnId)
					}));
				};
				return build();
			},

			// 递归查找路径
			findPath (nodes, target, path = [])  {
				for (const node of nodes) {
					const curPath = [...path, node.value]
					if (node.value === target) return curPath
					if (node.children) {
						const childPath = this.findPath(node.children, target, curPath)
						if (childPath){
							console.log(childPath);
							return childPath
						}
					}
				}
				return null
			},

			//--------------表格开始-搜索
			async apiArticleQueryList() {
				this.tableLoading = true
				this.query.staffId = window.sessionStorage.getItem('staffId')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiArticleQueryList, this.query);
				if (res.code == 200) {
					this.tableLoading = false
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiArticleQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiArticleQueryList()
			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false

			},

			// 添加
			tableAdd() {
				this.addArticleForm = {
					articleId: '',
					facilitatorId: 1,
					columnId: undefined,
					articleTitle: '',
					subTitle: '',
					author: '',
					articleResume: '',
					coverImage: '',
					articleInfo: '',
					articleSort: '',
					isTop: 2,
					styleConfig: '',
				}
				this.addVisible = true
			},
			async apiArticleAdd() {
				this.addConfirmLoading = true
				this.addForm.staffId = window.sessionStorage.getItem('staffId')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiArticleAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					if(this.$refs.addRuleForm) {
						this.$refs.addRuleForm.resetFields();
					}
					this.addConfirmLoading = false
					this.addVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiArticleQueryList()
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiArticleAdd()
					} else {
						return false;
					}
				});
			},

			// 修改
			async edit(item){
				this.editConfirmLoading = false
				// 设置表单数据，确保 priceIdList 属性存在
				// 由于 columnId 是数字，可能在任意层级，需先找到对应节点再回填 cascader
				const targetId = item.columnId
				const path = this.findPath(this.columnList, targetId)
				console.log(path);
				this.editForm = { ...item } // 保证响应式
				this.$set(this.editForm, 'columnIdPath', path)

				// 先打开弹窗
				this.editVisible = true

			},
			async apiArticleEdit() {
				this.editConfirmLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiArticleEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.editConfirmLoading = false
					this.editVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiArticleQueryList()
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiArticleEdit()
					} else {
						return false;
					}
				});
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.articleId)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiArticleDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiArticleDel(ids) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiArticleDel + '/'+ ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					await this.apiArticleQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.length === 1) {
					const item = this.tableData.find(item => item.columnId == this.tableSelectedRows[0].columnId)
					this.edit(item)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
            //文件上传-开始
            uploadPicUrlAdd(val){
                this.addForm.coverImage = val
            },
            uploadPicUrlEdit(val){
                this.editForm.coverImage =val
            },

			//文件上传-结束
			// 图集上传-开始
            uploadAtlasAdd(val){
                this.addForm.atlas = val
            },
			uploadAtlasEdit(val){
                this.editForm.atlas = val
            },
			// 图集上传-结束
			wangEditorFinish(editor) {
				this.wangEditor.editor = Object.seal(editor)
			},
			onChange(value) {
				this.query.columnId = value[value.length - 1]
			},
			onChangeAdd(value) {
				this.addForm.columnId = value[value.length - 1]
			},
			onChangeEdit(value) {
				this.editForm.columnId = value[value.length - 1]
			},
			displayRender({ labels }) {
				return labels[labels.length - 1];
			},
			
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
				};
			},
		},
		created() {
            this.apiColumnList()
            this.apiArticleQueryList()
		}
	};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>

</style>
